import { getPremiumUserExperienceType } from '../services/getPremiumUserExperienceType';
import { getTravelAssistantData } from '../services/GetTravelAssistantData';
import { store } from '../store/premiumTravelStore';
import { PremiumExperienceType } from '../store/premiumTravelStore';
import persistResponse from '../mutators/persistResponse';
import updateServiceActivation from '../mutators/updateServiceActivation';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';
import { getUserPersistedFlight } from 'owa-premium-flight';
import { GetUserPersistedFlightResponse } from 'owa-premium-flight';

export async function getExperienceTypeForUser() {
    if (!store.isInit) {
        // Get the current flights for the user
        var currentFlights = [];
        if (isFeatureEnabled('auth-PremiumTravelExpcf')) {
            currentFlights.push('auth-premiumtravelexpcf');
        }
        if (isFeatureEnabled('auth-PremiumTravelExp')) {
            currentFlights.push('auth-premiumtravelexp');
        }
        if (isFeatureEnabled('auth-PremiumTravelActivateRamp')) {
            currentFlights.push('auth-premiumtravelactivateramp');
        }
        if (isFeatureEnabled('auth-PremiumTravelUpsellRamp')) {
            currentFlights.push('auth-premiumtravelupsellramp');
        }
        // Get the user experience type from the server and save to store
        let jsonResponse = await getPremiumUserExperienceType(currentFlights);
        persistResponse(jsonResponse);

        if (jsonResponse != PremiumExperienceType.None) {
            let persistedFlightsResponse: GetUserPersistedFlightResponse = await getUserPersistedFlight();
            logUsage(
                'GetUserExperienceType',
                {
                    clientFlights: currentFlights.toString(),
                    experienceType: jsonResponse && jsonResponse.toString(),
                    sdsPersistedFlights:
                        persistedFlightsResponse?.flightNames &&
                        persistedFlightsResponse.flightNames.toString(),
                },
                {
                    isCore: true,
                }
            );
        }

        let premiumUserEntityResponse = await getTravelAssistantData();
        updateServiceActivation(premiumUserEntityResponse);
    }
    return store.premiumExperienceType;
}
